import { FlagValues } from '../api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';

export class FeatureFlagRegistry {
  private featureFlags: FlagValues = {};

  loadFeatureFlags(featureFlags: FlagValues): void {
    this.featureFlags = {
      ...featureFlags,
      ...this.featureFlags,
    };
  }

  getFeatureFlag(featureFlag: string): unknown {
    return this.featureFlags ? this.featureFlags[featureFlag] : null;
  }

  clearFeatureFlags(): void {
    this.featureFlags = {};
  }
}
